<!-- 数据报表 -->
<template>
    <div class='container containerBox'>
        <div class="handleForm" ref="handleForm">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <!-- <el-form-item label="表计">
					<span></span>
                </el-form-item> -->
                <el-form-item label="时间范围">
                    <el-date-picker
                        v-model="form.time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="choseTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="时间间隔">
                    <el-select v-model="form.timeInterval" placeholder="请选择时间间隔">
                        <el-option
                            v-for="item in timeInterval"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
					<el-button type="primary" @click="onExport">导出</el-button>
                </el-form-item>
            </el-form>
        </div>
        <template v-if="tableData.length>0 && !showChart">
            <div>
                <el-table class="exportTable" :data="tableData" stripe :height="maxHeight" border>
					<el-table-column
					    label="日期"
					    prop="symbolictime"
						min-width="100"
					    >
					</el-table-column>
                    <el-table-column
                        label="累计冷量"
                        prop="cool"
                        >
                    </el-table-column>
                    <el-table-column
                        label="累计热量"
                        prop="heat"
                        >
                    </el-table-column>
					<el-table-column
					    label="流量"
					    prop="discharge"
					    >
					</el-table-column>
					<el-table-column
					    label="供水温度(℃)"
					    prop="intemperature"
					    >
					</el-table-column>
					<el-table-column
					    label="回水温度(℃)"
					    prop="cycletemperature"
					    >
					</el-table-column>
					
                </el-table>
            </div>
        </template>

        <div class="echart-box" v-if="showChart">
            <div id="main_t" class="main" ref="myEchart_t" style="width: 100%;height:500px"></div>
        </div>

        <div class="noData" v-if="tableData.length===0">-- 暂无数据 --</div>

        <!-- 设置报表展示数据 -->
        <div class="changeBox" @click="handleChangeChart">
            <span :class="[showChart ? 'iconfont icon-biaoge': 'iconfont icon-zhexiantu']"></span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import echarts from "echarts"
import { getMaxHeigth,  FormatDate,FormatNextDate,FormatPrevDate,reliangbiaoInfo  } from '@/utils/utils'
import Service from '@/api/Service'
// import config from '@/config.js'
// import { fmtInt32Byte, fmtDoubleByte }  from '@/utils/HexToSingleBatch.js'

import FileSaver from 'file-saver'
import XLSX from 'xlsx'

const nowDay = FormatDate("yyyy-MM-dd");
const nextDay = FormatNextDate("yyyy-MM-dd");

const SETTING_TYPE = 2; //  温度配置
const timeInterval = [
                {
                    value: 1,
                    name: '小时'
                },
                {
                    value: 2,
                    name: '天'
                },
                {
                    value: 3,
                    name: '月'
                },
            ]
export default {
    name:  'devicereport',
    data() {
        return {
            form: {
                time: [],
                start_time: nowDay,
                end_time: nextDay,
                device: '',
                collector: '',
                timeInterval: 1,
				terminal_id:0
            },

            collectorList: [], // 集控器列表
            deviceList: [], // 设备列表
            pageConfigList: [],  // 页面变量配置
            plcConfigData: [],  //  plc变量配置
            getPlcCurve: [],    // 变量值

            cols: [],
            tableData: [],
            loading: false,
            index: 0,

            total: 100,
            page_num: 1,
            page_sum: 5,
            maxHeight: 500,

            setting_type: SETTING_TYPE,

            falutMsg: [],

            timeInterval: timeInterval,

            // 曲线
            chart_x: null,

            echartsData: {
                categories: [],
                series: [],
            },

            showChart: false,
        }
    },

    computed: {
        ...mapGetters(["machine"]),
    },

    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart_x.dispose();
        this.chart_x = null
    },
    async created() {
		this.form.terminal_id = this.$route.params.oid;
		// this.getPlcData()
        // await this.getDeviceList();
    },

    methods: {
        // 获取表计信息
        async getDeviceList() {
            let params = Object.assign({}, { page_num: 1, page_sum: 40 });
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
                this.form.device = list[0].oid;
                await this.getData();
                await this.handleChangePLC(list[0].oid)
            }
        },
        async getData() {
            // 表头
            let list = await Service.getServerRoombypid();
            list = list === 'success' ? [] : list
            if(list.length>0) {
                this.pageConfigList = list;
            }
        },
		// 导出
		async onExport() {
			let data = await Service.getTerminalbyidInfo({oid:this.form.terminal_id})
			let exportname= data[0].terminal_serial
			// var wb = XLSX.utils.table_to_book(document.querySelector('.exportTable'))
			// var wbout = XLSX.write(wb, { bookType: 'xls', bookSST: true, type: 'array' })
			// try {
			// 	FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), exportname)
			// } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
			// 	return wbout
			if(this.tableData.length==0){
			  this.$message.error("目前表格没有数据不能导出");
			}else{
			  // 这是需要导出的表头
			  let headerArr = ['日期','累计冷量','累计热量','流量','供水温度(℃)','回水温度(℃)']
			  // 这是数组中obj中的属性
			  let keyArr = ['symbolictime','cool','heat','discharge','intemperature','cycletemperature']
			  this.$tableExport.setTableData(this.tableData,headerArr,keyArr,exportname)
			}
		},
        
   //      async onExport() {
			// let data = await Service.getTerminalbyidInfo({oid:this.form.terminal_id})
			// // let exportname= data[0].TerminalSerial + '.xlsx'
			// let exportname= 'wer' + '.doc'
			// var blob = new Blob([document.getElementsByClassName("exportTable")[0].outerHTML], {
			// 	type: "application/msword"
			// });	            
			// saveAs(blob,  exportname);
   //      },
        // 获取PLC addr配置
        async handleChangePLC(terminal_id) {
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 500,
            }
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.plcConfigData = res.list;
                // 获取设备统计数据
                this.handleSetType(this.setting_type)
            }
        },
        // 获取统计数据
        async getPlcData(){
            this.tableData = []
            let params = {}
                params.terminal_id = this.form.terminal_id
                params.time_interval = this.form.timeInterval
				// params.from = '2020-09-15'
				// params.to = '2020-09-16'
                params.from = this.form.start_time
                params.to = this.form.end_time
				
            let res = await Service.getHistoryReport(params);
            let list = res
            if(list.length>0) {
                this.tableData = this.formatData(list)
                this.echartsData = this.formatChartData(this.formatDataecharts(list))
                if(this.showChart) {
                    this.chartConfig_x(this.echartsData)
                }
            }else{
                this.tableData = this.formatData([])
                this.echartsData = {
                    categories: [],
                    series: [],
                }
                if(this.showChart) {
                    this.chartConfig_x(this.echartsData)
                }
            }
            
        },
		// 格式化表格数据(echsrts用)
		formatDataecharts(list) {
			if(list.length<=0) return [];
			// 遍历表头
			let arr = [];
			// 遍历后台返回数据  格式化数据
			list.map(v => {
				let newObj = {}
				newObj.symbolictime = v.symbolic_time
				
				newObj.cool = v.termianl_data.data.cooling_capacity
				newObj.heat = v.termianl_data.data.heating_capacity
				newObj.discharge = v.termianl_data.data.discharge
				newObj.intemperature = v.termianl_data.data.in_temperature
				newObj.cycletemperature = v.termianl_data.data.cycle_temperature
				arr.push(newObj);
			})
			return arr
		},
        // 格式化表格数据(表格用)
        formatData(list) {
            if(list.length<=0) return [];
            // 遍历表头
            let arr = [];
            // 遍历后台返回数据  格式化数据
            list.map(v => {
                let newObj = {}
				newObj.symbolictime = v.symbolic_time
				
				// newObj.cool = v.termianl_data.v.termianl_data.data.cooling_capacity
				// newObj.heat = v.termianl_data.v.termianl_data.data.heating_capacity
				// newnewObj.discharge = v.termianl_data.v.termianl_data.data.discharge
				//累计冷量
				let cool
				if(v.termianl_data.data.cooling_capacity_unit){
					cool = v.termianl_data.data.cooling_capacity_unit.toString(16)
				}else{
					cool = 'hh'
				}
				if(cool =='2' ){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(Wh)"
				}else if(cool == '3'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(10Wh)"
				}else if(cool == '4'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(100Wh)"
				}else if(cool == '5'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(KWh)"
				}else if(cool == 'b'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(KJ)"
				}else if(cool == 'c'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(10KJ)"
				}else if(cool == 'd'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(100KJ)"
				}else if(cool == 'e'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(MJ)"
				}else if(cool == 'f'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(10MJ)"
				}else if(cool == '10'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(100MJ)"
				}else if(cool == '11'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(GJ)"
				}else if(cool == '12'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(10GJ)"
				}else if(cool == '13'){
					newObj.cool = v.termianl_data.data.cooling_capacity + "(100GJ)"
				}else{
					newObj.cool = v.termianl_data.data.cooling_capacity
				}
				//累计热量
				let heat
				if(v.termianl_data.data.heating_capacity_unit){
					heat = v.termianl_data.data.heating_capacity_unit.toString(16)
				}else{
					heat = 'hh'
				}
				if(heat =='2' ){
					newObj.heat = v.termianl_data.data.heating_capacity + "(Wh)"
				}else if(heat == '3'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(10Wh)"
				}else if(heat == '4'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(100Wh)"
				}else if(heat == '5'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(KWh)"
				}else if(heat == 'b'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(KJ)"
				}else if(heat == 'c'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(10KJ)"
				}else if(heat == 'd'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(100KJ)"
				}else if(heat == 'e'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(MJ)"
				}else if(heat == 'f'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(10MJ)"
				}else if(heat == '10'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(100MJ)"
				}else if(heat == '11'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(GJ)"
				}else if(heat == '12'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(10GJ)"
				}else if(heat == '13'){
					newObj.heat = v.termianl_data.data.heating_capacity + "(100GJ)"
				}else{
					newObj.heat = v.termianl_data.data.heating_capacity
				}
				//  累计流量
				let disc
				if(v.termianl_data.data.discharge_unit){
					disc = v.termianl_data.data.discharge_unit.toString(16)
				}else{
					disc = 'hh'
				}
				
				if(disc == '26'){
					newObj.discharge = v.termianl_data.data.discharge + "(mL)"; 
				}else if(disc == '27'){
					newObj.discharge = v.termianl_data.data.discharge + "(10mL)"; 
				}else if(disc == '28'){
					newObj.discharge = v.termianl_data.data.discharge + "(100mL)"; 
				}else if(disc == '29'){
					newObj.discharge = v.termianl_data.data.discharge + "(L)"; 
				}else if(disc == '2a'){
					newObj.discharge = v.termianl_data.data.discharge + "(10L)"; 
				}else if(disc == '2b'){
					newObj.discharge = v.termianl_data.data.discharge + "(100L)"; 
				}else if(disc == '2c'){
					newObj.discharge = v.termianl_data.data.discharge + "(m³)"; 
				}else{
					newObj.discharge = v.termianl_data.data.discharge
				}
				
				newObj.intemperature = v.termianl_data.data.in_temperature
				newObj.cycletemperature = v.termianl_data.data.cycle_temperature
                arr.push(newObj);
            })
            return arr
        },
         // 格式化曲线数据
        formatChartData(list) {
            if(list.length <= 0) {
                return {
                    categories: [],
                    series: []
                }
            }
            // 遍历表头
            let categories = [];
            let series = [];
            let valueData = []
			list.map(v=>{categories.push(v.symbolictime)})
			let tagname=['累计冷量','累计热量','流量','供水温度','回水温度']
			for(var i=0;i<tagname.length;i++){
				list.map(v=>{
					if(i == 0){
						valueData.push(v.cool)
					}else if(i ==1){
						valueData.push(v.heat)
					}else if(i ==2){
						valueData.push(v.discharge)
					}else if(i ==3){
						valueData.push(v.intemperature)
					}else{
						valueData.push(v.cycletemperature)
					}
				})
				series.push({
					name: tagname[i],
					type: 'line',
					data: valueData,
				})
				valueData=[]
			}
            return {
                categories,
                series
            }
        },
        handleChangeChart() {
            this.showChart = !this.showChart
            if(this.showChart) {
                this.$nextTick(()=>{
                    if(!this.chart_x) {
                        this.chart_x = echarts.init(this.$refs.myEchart_t); //这里是为了获得容器所在位置
                    }
                    this.chartConfig_x(this.echartsData)
                })
            }else{
                this.chart_x.dispose();
                this.chart_x = null
            }
        },
        // 曲线
        chartConfig_x(data) {
            let _t = this;
            window.onresize = this.chart_x.resize;
            if(data.categories.length === 0) {
                this.chart_x.clear();
                return
            }
            this.chart_x.clear();
            this.chart_x.setOption({ // 进行相关配置
                title: {
                    text: '',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: data.series.map(v=>{return v.name}),
                    x: 'center',
                    itemGap: 10,
                },
                xAxis: {
                    data: data.categories
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    },
                    splitLine: {
                        show: false
                    }
                },
                toolbox: {
                    left: 'right',
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                // 下发滑块
                dataZoom: [{
                    start: 30,
                    end: 70
                }, {
                    type: 'inside'
                }],
                series: data.series
            })
        },
        handleSetReport() {
            
        },
        // handleSetType(type) {
        //     this.setting_type = type
        //     let cols = this.pageConfigList.filter(v=>v.setting_type === type && v.terminal_id === this.form.device)
        //     if(cols.length<=0) {
        //         this.$message({
        //             message: '该设备下未配置报表信息',
        //             type: 'warning'
        //         });
        //         return
        //     }
        //     let arr = JSON.parse(cols[0].setting_data)
        //     // this.cols = arr.filter(v=>v.hidden === undefined || v.hidden === false)
        //     this.getPlcData(type);
        // },
        choseTime(val) {
			this.form.start_time = val[0]
			this.form.end_time = val[1]
        },
        // 查询
        onSubmit() {
            this.getPlcData()
        },
        fmtExportData(){
            let arr = [];
            this.cols.map(v=>{
                let obj = {}
                if(this.setting_type === 2){
                    obj.unit = 0.1
                }
                if(this.setting_type === 3){
                    obj.unit = 0
                }
                obj.name = v.label;
                obj.addr = v.addr;
                arr.push(obj)
            })
            return JSON.stringify(arr)
        },
        handleSizeChange (val) {
            console.log(`每页 ${val} 条`);
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            console.log(`当前页: ${val}`)
            this.page_num = val
            this.getData()
        },

        // fmtConcatArr(list) {
        //     let newArr = [];
        //     list.map(v=>{
        //         let Len = newArr.length;
        //         let bool = true;
        //         for (let i = 0; i < Len; i++) {
        //             const v1 = newArr[i];
        //             if(v.date === v1.date) {
        //                 v1.data = v1.data.concat(v.data);
        //                 bool = false;
        //             }
        //         }
        //         if(bool) {
        //             newArr.push(v) 
        //         } 
        //     })
        //     return newArr
        // },
    }
}

</script>
<style lang='less' scoped>
.noData{
    line-height: 100px;
    text-align: center;
    font-size: 14px;
    color: #999;
}
    .changeBox{
        position: fixed;
        right: 200px;
        bottom: 200px;
        z-index: 9999;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        background-color: #009BAC;
        color: #fff;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        box-shadow: 0 0 10px rgba(0, 0, 0, .7);
        transition: all .1s ease-in-out;
        &:hover{
            transform: scale(1.1);
        }
        span{
            font-size: 24px;
        }
    }
</style>